import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { Button } from '../../button/esm';
import { BaseCustomButton } from './components/base-custom-button/base-custom-button.js';
import 'classnames';
import './constants/default-colors.js';

var CustomButton = forwardRef(function (_a, ref) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return (React.createElement(BaseCustomButton, __assign({ ref: ref }, restProps, { componentButton: Button }), children));
});
CustomButton.displayName = 'CustomButton';

export { CustomButton };
